"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
String.prototype.toInt = function (allowNAN = false) {
    const t = parseInt(this);
    if (!allowNAN && Number.isNaN(t))
        return 0;
    return t;
};
String.prototype.toFloat = function (allowNAN = false) {
    const t = parseFloat(this);
    if (!allowNAN && Number.isNaN(t))
        return 0;
    return t;
};
String.prototype.toCapitalCase = function () {
    return this.toLowerCase().split(' ').map(x => x.substring(0, 1).toUpperCase() + x.substring(1)).join(' ');
};
String.prototype.toCamelCase = function () {
    return this.toLowerCase().replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');
};
String.prototype.toSlug = function () {
    return this.toLowerCase()
        .split('?').join('�')
        .split('/').join('-')
        .split('\\').join('-')
        .split('"').join('')
        .split("'").join('')
        .split('�').join('a')
        .split('�').join('e')
        .split('�').join('i')
        .split('�').join('o')
        .split('�').join('u')
        .split('�').join('n')
        .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
        .trim()
        .replace(/\s+/g, '-')
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
String.prototype.toSlugID = function () {
    return this.toLowerCase()
        .split('?').join('�')
        .split('/').join('-')
        .split('\\').join('-')
        .split('"').join('')
        .split("'").join('')
        .split('�').join('a')
        .split('�').join('e')
        .split('�').join('i')
        .split('�').join('o')
        .split('�').join('u')
        .split('�').join('n')
        .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
        .trim()
        .replace(/\s+/g, '_')
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
};
String.prototype.clean = function (opt) {
    let e = this.toLowerCase()
        .split('?').join('�')
        .split('/').join('-')
        .split('\\').join('-')
        .split('"').join('')
        .split("'").join('');
    if (opt?.cleanAcents) {
        e = e.split('�').join('a')
            .split('�').join('e')
            .split('�').join('i')
            .split('�').join('o')
            .split('�').join('u');
    }
    if (opt?.allowUnderscore) {
        e = e.replace(/[`~!@#$%^&*()|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '');
    }
    else {
        e = e.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
    }
    e.trim();
    return e;
};
String.prototype.cut = function (lenght) {
    if (typeof lenght === 'number')
        return this.substring(0, lenght);
    return this;
};
String.prototype.delete = function (s) {
    if (typeof s === 'string')
        return this.split(s).join('');
    else if (lodash_1.isArray(s)) {
        let a = this;
        for (let e of s) {
            a = a.split(e).join('');
        }
        return a;
    }
    return this;
};
String.prototype.insert = function (position, value) {
    if (typeof position === 'number')
        return this.substring(0, position) + value + this.substring(position);
    return this;
};
String.prototype.format = function (...args) {
    return this.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match;
    });
};
String.prototype.toCurrency = function (...args) { return parseFloat(this).toCurrency(...args); };
String.prototype.toDecimal = function (...args) { return parseFloat(this).toDecimal(...args); };
String.prototype.toRate = function (...args) { return parseFloat(this).toRate(...args); };
String.prototype.isNan = function (...args) { return parseFloat(this).isNan(...args); };
String.prototype.left = function (position) {
    if (!this)
        return '';
    return this.substring(0, position);
};
String.prototype.right = function (position) {
    if (!this)
        return '';
    if (this.length < position)
        return this;
    return this.substring(this.length - position);
};
